var windowScrollTopBeforeShowPhotoviewer = 0,
    showPreloaderTimeout = false;


$(function(){

    $(window).resize(function() {
        if (photoviewerDetected()) photoviewerContentSetPosition();
    });

    $('.show-photoviewer').click(function () {
        if (!photoviewerDetected()) showPhotoviewer($(this));
    });


    $('.photoviewer .back, .close-photoviewer-button').on('click', function(event) {
        hidePhotoviewer();
    });


    $('.photoviewer-content-img').on('click', function (event) {
        var photoviewer = $('.photoviewer');

        if (!photoviewer.hasClass('one')) {
            var amount = photoviewer.data('amount'),
                index = photoviewer.data('index') == (amount - 1) ? 0 : photoviewer.data('index') + 1;

            showPhotoviewerCarouselElement(index);
        } else hidePhotoviewer();
    });


    $('.photoviewer-nav-next').on('click', function(event) {
        var amount = $('.photoviewer').data('amount'),
            index = $('.photoviewer').data('index') == (amount - 1) ? 0 : $('.photoviewer').data('index') + 1;

        showPhotoviewerCarouselElement(index);
    });


    $('.photoviewer-nav-prev').on('click', function(event) {
        var amount = $('.photoviewer').data('amount'),
            index = $('.photoviewer').data('index') == 0 ? (amount - 1) : $('.photoviewer').data('index') - 1;

        showPhotoviewerCarouselElement(index);
    });


    $('.photoviewer-carousel-wrapper').on('click', '.photoviewer-carousel-element', function(event) {
        showPhotoviewerCarouselElement($(this).find('img').data('index'));
    });


    $('.photoviewer-carousel-switcher').on('click', function(event) {
        var container = $(this).parents('.photoviewer-bottom-container'),
            newHeight = container.hasClass('open') ? $('.photoviewer-bottom-bar').outerHeight() + 'px' : ($('.photoviewer-carousel-wrapper').outerHeight() + $('.photoviewer-bottom-bar').outerHeight()) + 'px';

        container.animate(
            {
                height: newHeight,
            },{
                duration: animateSpeed,
                easing: 'swing',
                step: function() {
                    photoviewerContentSetPosition();
                },
                complete: function() {
                    container.toggleClass('open');
                },
            }
        );
    });


    if (photoviewerDetected()) {
        $('.photoviewer-content-img').load(function (event) {
            var photoviewer = $('.photoviewer');

            clearTimeout(showPreloaderTimeout);
            photoviewer.find('.photoviewer-content-preloader').addClass('inactive');
            photoviewer.data('image-loaded', true);
            photoviewerContentSetPosition($(this).width(), $(this).height());
            $(this).css({width: '100%', height: '100%'}).addClass('visible').fadeIn(animateSpeed / 2);
        });
    }
});


// Показывает Просмотрщик изображений
function showPhotoviewer(jqPhotoviewerElement) {
    var src = jqPhotoviewerElement.data('pv'),
        container = jqPhotoviewerElement.parents('.photoviewer-container'),
        index = container.find('.show-photoviewer').index(jqPhotoviewerElement),
        amount = container.find('.show-photoviewer').length,
        infoBlock = container.find('.photoviewer-info-block'),
        photoviewer = $('.photoviewer'),
        content = photoviewer.find('.photoviewer-content'),
        img = photoviewer.find('.photoviewer-content-img');

    if (amount > 1) {
        container.find('.show-photoviewer').each(function(index, el) {
            var pv = $(this).data('pv'),
                pvThumb = $(this).data('pv-thumb');

            $('.photoviewer-carousel-wrapper').append('<div class="photoviewer-carousel-element"><img src="' + pvThumb + '" data-index="' + index + '" data-pv="' + pv + '"></div>');
        });

        $('.photoviewer-counter span').eq(0).html(index + 1);
        $('.photoviewer-counter span').eq(1).html(amount);

        $('.photoviewer-carousel-element').eq(index).addClass('active');
        $('.photoviewer-carousel-wrapper').removeClass('invisible');
        $('.photoviewer-nav-wrapper').removeClass('invisible');
        $('.photoviewer-carousel-switcher').removeClass('invisible');
        $('.photoviewer').removeClass('one');
    }
    else {
        $('.photoviewer-carousel-wrapper').addClass('invisible');
        $('.photoviewer-nav-wrapper').addClass('invisible');
        $('.photoviewer-carousel-switcher').addClass('invisible');
        $('.photoviewer').addClass('one');
        $('.photoviewer-bottom-container').removeClass('open');
    }

    photoviewerContentSetPosition();
    img.attr('src', src);
    photoviewer.data('index', index).data('amount', amount);

    getPhotoviewerInfo(infoBlock);

    windowScrollTopBeforeShowPhotoviewer = windowScrollTop;

    photoviewer.fadeIn(animateSpeed, function() {
        $(window).scrollTop(0);
        $('body').wrapInner( '<div class="unvisible-body"></div>');
        $('.photoviewer').appendTo('body');
        $('.unvisible-body').css('display', 'none');
        $(this).addClass('visible');
    });
}


// Скрывает Просмотрщик изображений
function hidePhotoviewer() {
    if (photoviewerDetected()) {
        var photoviewer = $('.photoviewer');

        $('.unvisible-body >').appendTo('body');
        $('.unvisible-body').remove();
        $(window).scrollTop(windowScrollTopBeforeShowPhotoviewer);
        photoviewer.addClass('fixed');

        photoviewer.fadeOut(0, function() {
            $(this).removeClass('visible fixed').removeData();
            photoviewer.find('.photoviewer-carousel-element').empty().remove();
            photoviewer.find('.photoviewer-content').removeAttr('style');
            photoviewer.find('.photoviewer-content-img').removeClass('visible').removeAttr('src').removeAttr('style');
            photoviewer.find('.photoviewer-content-preloader').removeClass('inactive');
            photoviewer.find('.photoviewer-bottom-container').removeAttr('style');
        });
    }
    else return false;
}


// Задает положение для блока в Просмотрщике, в котором выводится активная фотография
function photoviewerContentSetPosition(width, height) {
    var padWidth = 30,
        padHeight = 0,
        left = 0,
        top = 0,

        photoviewer = $('.photoviewer'),
        content = photoviewer.find('.photoviewer-content'),
        topBarHeight = photoviewer.find('.photoviewer-top-bar').outerHeight(),
        bottomBarHeight = photoviewer.find('.photoviewer-bottom-container').outerHeight(),
        maxAvalableWindowWidth = window.innerWidth - padWidth * 2,
        maxAvalableWindowHeight = window.innerHeight - topBarHeight - bottomBarHeight - padHeight * 2,

        scaleWindowWidth,
        scaleWindowHeight,
        width = width ? width : content.width(),
        height = height ? height : content.height(),
        isScaleOrigin = photoviewer.hasClass('scale-original') ? true : false;

    scaleWindowHeight = height * maxAvalableWindowWidth / width;
    scaleWindowWidth = maxAvalableWindowWidth;

    if (scaleWindowHeight >= maxAvalableWindowHeight) {
        scaleWindowWidth = scaleWindowWidth * maxAvalableWindowHeight / scaleWindowHeight;
        scaleWindowHeight = maxAvalableWindowHeight;
    }

    width = scaleWindowWidth;
    height = scaleWindowHeight;

    left = (maxAvalableWindowWidth - width) / 2 + padWidth;
    top = (maxAvalableWindowHeight - height) / 2 + topBarHeight + padHeight;

    content.removeAttr('style').css({width: width, height: height, top: top, left: left});
}


// Показывает изображение из карусели с индексом index
function showPhotoviewerCarouselElement(index) {
    var photoviewer = $('.photoviewer');

    photoviewer.find('.photoviewer-carousel-element.active').removeClass('active');
    photoviewer.find('.photoviewer-carousel-element').eq(index).addClass('active');

    showPreloaderTimeout = setTimeout(function() {
        photoviewer.find('.photoviewer-content-preloader').removeClass('inactive');
    }, animateSpeed);

    photoviewer.find('.photoviewer-counter span').eq(0).html(index + 1);

    photoviewer.find('.photoviewer-content').removeAttr('style');
    photoviewer.data('index', index).removeClass('scale-original').removeData('image-loaded').find('.photoviewer-content-img').removeAttr('style').removeClass('visible').attr('src', $('.photoviewer-carousel-element').eq(index).find('img').data('pv'));
    photoviewerContentSetPosition();
}


// Проверка на существование видимого Просмотрщика изображений
function photoviewerDetected() {
    return ($('.photoviewer').hasClass('visible')) ? true : false;
}


// Переносит информацию из инфо-блока в Просмотрщик
function getPhotoviewerInfo(jqInfoBlock) {
    var photoviewer = $('.photoviewer');

    if (jqInfoBlock.find('.photoviewer-top-bar').html()) photoviewer.find('.photoviewer-top-bar').html(jqInfoBlock.find('.photoviewer-top-bar').html());
    else photoviewer.find('.photoviewer-top-bar').html('');
}